import Vue from 'vue'
import FavoriteStopsMixin from 'js/mixins/favorite-stops-mixin'

import template from './header.pug'

// @vue/component
export default Vue.extend({
  template: template(),

  mixins: [FavoriteStopsMixin],

  props: {
    stop: {
      type: Object,
      required: true
    }
  },

  methods: {
    hideStop() {
      this.$emit('hide-stop')
    }
  }
})
